import * as React from 'react'

import { cn } from '@/lib/utils'

interface InputProps extends React.ComponentProps<'input'> {
  label?: string
}

function Input({ className, type, label, id, ...props }: InputProps) {
  const inputId = id || React.useId()

  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label
          htmlFor={inputId}
          className="text-sm font-medium text-ink-soft"
        >
          {label}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        data-slot="input"
        className={cn(
          'w-full min-h-[48px] px-4 bg-paper-card border border-ink-faint rounded-lg text-base text-ink placeholder:text-ink-muted transition-colors',
          'focus:outline-none focus:border-ink',
          'disabled:pointer-events-none disabled:opacity-50',
          className,
        )}
        {...props}
      />
    </div>
  )
}

export { Input }
